import { render, staticRenderFns } from "./appcheck.vue?vue&type=template&id=3276e96f"
import script from "./appcheck.vue?vue&type=script&lang=js"
export * from "./appcheck.vue?vue&type=script&lang=js"
import style0 from "./appcheck.vue?vue&type=style&index=0&id=3276e96f&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports